var _circle, _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E02020",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8 8H24V24H8z",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E02020",
    fillRule: "evenodd",
    d: "M18.667 12H22c.368 0 .667.299.667.667 0 .368-.299.666-.667.666h-.666v7.334c0 1.104-.896 2-2 2h-6.667c-1.105 0-2-.896-2-2v-7.334H10c-.368 0-.666-.298-.666-.666 0-.368.298-.667.666-.667h3.334v-1.113c.032-.889.777-1.584 1.666-1.554h2c.889-.03 1.634.665 1.667 1.554V12zM14 19.333c.368 0 .667-.298.667-.666V16c0-.368-.299-.667-.667-.667-.368 0-.666.299-.666.667v2.667c0 .368.298.666.666.666zm.667-8.446c0-.107.14-.22.333-.22h2c.194 0 .334.113.334.22V12h-2.667v-1.113zM18 19.333c.368 0 .667-.298.667-.666V16c0-.368-.299-.667-.667-.667-.368 0-.666.299-.666.667v2.667c0 .368.298.666.666.666z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.2080901a.svg";
export { ForwardRef as ReactComponent };